<template>
	<div class="word-wrap overflow-auto default-bar">
		<p>
			本隐私协议与您所使用的浙江新闪新能源科技有限公司充电服务以及该服务所包括的各种业务功能（以下统称“我们的服务与/或产品”）息息相关，希望您在使用我们的服务与/或产品前仔细阅读并确认您已经充分理解本协议所写明的内容，并让您可以按照本隐私协议的指引做出您认为适当的选择。本隐私协议中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私协议后（我们会及时提示您更新的情况）继续使用我们的服务与/或产品，即意味着您同意本隐私协议(含更新版本)内容，并且同意我们按照本隐私协议收集、使用、保存和共享您的相关信息。
		</p>

		<p>本隐私协议适用浙江新闪新能源科技有限公司充电的相关网站，包括 “浙江新闪新能源科技有限公司充电”微信小程序和公众号及其他客户端。</p>

		<p>如对本隐私协议或相关事宜有任何问题，您可随时拨打我们客服电话 【400-806-0808】[9:00 - 17:30 (法定假日除外)]的方式与我们联系。</p>

		<p>目录</p>

		<p>一、我们如何收集和使用您的个人信息</p>
		<p>二、我们如何使用 Cookie 和同类技术</p>
		<p>三、我们如何存储您的个人信息</p>
		<p>四、我们如何使用您的个人信息</p>
		<p>五、我们如何对外使用您的个人信息</p>
		<p>六、未成年人信息的保护</p>
		<p>七、通知和修订</p>
		<p>八、如何联系我们</p>

		<p><strong>一、我们如何收集和使用您的个人信息</strong></p>

		<p>
			个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私协议中涉及的个人信息包括：基本信息（包括个人姓名、性别、个人电话号码）；网络身份标识信息（包括账户名、账户昵称、IP地址、及与前述有关的口令、口令保护答案）；个人财产信息（订单记录、浙江新闪新能源科技有限公司充电优惠券等虚拟财产信息）；个人上网记录（包括微信小程序浏览记录、使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如OPEN
			ID / UNION ID 信息等在内的描述个人常用设备基本情况的信息）；个人位置信息（包括精准定位信息、经纬度等）；其他个人信息。</p>

		<p>
			个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私协议中涉及的个人敏感信息包括：您的财产信息（包括交易和消费记录、浙江新闪新能源科技有限公司充电优惠券等虚拟财产信息）；网络身份标识信息（包括账号名、用户昵称）；其他信息（手机号码、微信小程序浏览记录）。
		</p>

		<p>我们收集您的个人信息的最终目的是为了向您提供更好的服务、产品，优化并丰富您的用户体验，这些个人信息是能够单独或者与其他信息结合识别您的个人身份的信息。</p>

		<p>以上个人信息均是您自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用我们提供的服务、产品，或者可能对您使用服务或产品造成一定的影响。</p>

		<p>（一）您须授权我们收集和使用您个人信息的情形</p>

		<p>当您适用浙江新闪新能源科技有限公司充电服务费时，需要向我们提供或允许我们收集您的下列与该等服务相关的个人信息。</p>
		<p>1.账号登入：当您首次登录浙江新闪新能源科技有限公司小程序时，您需要提供手机号码信息注册成为我们的用户。</p>
		<p>
			如果您通过第三方平台（如微信）登录浙江新闪新能源科技有限公司小程序时，我们将按照第三方平台的个人信息保护政策共享获得您在第三方的手机号码，该项信息为您注册新浙江新闪新能源科技有限公司账号所必需，若您不授权使用该等信息，您将无法登录浙江新闪新能源科技有限公司小程序使用我们的服务。
		</p>
		<p>2.充电服务：为了向您展示您附件充电站点，您需授权定位功能获取您的地理位置信息后展示您附近的充电点位；如您不提供授权，系统将展示默认所有充电站点。</p>
		<p>
			3.支付服务：在您下单时，您可以选择与我们合作的第三方支付机构（包括但不限于微信支付，“以下简称支付机构”）所提供的支付服务，该支付功能本身并不收集您的个人信息，但我们需要将您的实付金额、优惠券的使用情况（如有）以及系统自动生成的交易流水号与这些支付机构分享（代扣模式下还将分享您的支付方式），以实现其确认您的支付指令并完成支付。
		</p>
		<p>4.客服咨询：当您与我们客户进行联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您取得联系或帮助您解决/定位问题，或记录相关问题的处理方案及结果。</p>
		<p>5.设备权限：获取相机/摄像头权限是用于实现扫码充电功能。</p>


		<p><strong>二、我们如何使用 Cookie 和同类技术</strong></p>

		<p>（一）Cookies的使用</p>

		<p>1、为确保微信小程序正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies
			是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。</p>

		<p>2、我们不会将 Cookies 用于本隐私协议所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除手机上保存的所有
			Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
			Cookies；另外，您也可以清除浏览器内保存的所有Cookies，移动端退出登录后也可以清除所有Cookies。但如果您这么做，您可能需要在每一次访问
			“浙江新闪新能源科技有限公司”微信小程序时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</p>

		<p>（二）网络Beacon和同类技术的使用</p>

		<p>除 Cookie 外，我们还会在网站上使用网络Beacon等其他同类技术。我们的网页上常会包含一些电子图像（称为"单像素" GIF 文件或 "网络 beacon"）。我们使用网络beacon的方式有：</p>

		<p>1、通过在 “浙江新闪新能源科技有限公司”微信小程序上使用网络beacon，计算用户访问数量，并通过访问cookie 辨认注册的浙江新闪新能源科技有限公司充电用户。</p>

		<p>2、通过得到的cookies信息，为您提供个性化服务。</p>

		<p><strong>三、我们如何存储您的个人信息</strong></p>

		<p>3.1 我们在中华人民共和国境内收集和产生的您的个人信息将存储于中华人民共和国境内。</p>

		<p>3.2
			如部分业务涉及跨境业务，我们需要向境外机构传输境内收集的相关个人信息的，我们会根据国内法律、行政法规和相关监管部门的规定执行，并向您说明个人信息出境的目的及涉及的个人信息类型，征得您的同意。我们会要求信息接收方按照本隐私协议的要求及其他任何相关的安全保密措施对其所获得的您的个人信息进行保密。
		</p>

		<p>3.3
			我们将会基于您使用平台服务的必要以及在法律法或监管规定的期限内保存您的个人信息。如您终止使用我们的产品与/或服务，我们将会停止收集和使用您的个人信息，法律法规或监管部门另有规定的除外。如我们的产品与/或者服务停止运营，我们也将及时停止收集和使用您的个人信息。同时，将停止运营的通知通过我们官方渠道公告或站内信的形式通知您，并将对保存的您的个人信息进行删除或匿名化处理。
		</p>

		<p><strong>四、我们如何使用您的个人信息</strong></p>

		<p>基于国家相关法律法规的规定，以及为向您提供服务及提升服务质量等目的（包括支持我们开发新产品或完善已有产品功能），我们可能将在以下情形下使用您的相关信息，并在使用中采取充分的措施保障安全：</p>

		<p>4.1 基于上述收集目的以及向您提供充电服务；</p>

		<p>4.2 根据国家相关部门的要求向相关部门进行报告；</p>

		<p>4.3 在您使用平台服务时，我们将您的信息用于身份验证、客户服务、安全防范等，确保我们向您提供的产品和服务的安全性；</p>

		<p>4.4 对您的身份信息、交易信息等进行综合统计、分析或加工等处理，以便为您提供更加准确、个性、流畅的产品及服务，或帮助我们评估、改善、设计我们的产品及服务；使我们了解您如何接入和使用平台服务，从而满足您的个性化需求；</p>

		<p>4.5 为了提升用户体验，改进我们的产品和服务，我们可能会根据您的信息形成用户画像，用于向您发送营销活动通知、商业性电子信息以及提供与您相关的广告；如果您对此有疑问，可以通过客服电话联系我们。</p>

		<p>4.6 经您授权的其他用途。</p>

		<p>
			如我们要将您的个人信息用于本协议未载明的其他用途或者超出收集您个人信息所称的目的具有直接或合理关联的范围后，我们会在再次使用您个人信息前时，按照法律法规及国家标准的要求以点击确认协议、具体场景下的点击确认动作等形式再次征求您的同意。
		</p>

		<p><strong>五、我们如何对外使用您的个人信息</strong></p>

		<p>5.1 委托处理</p>

		<p>
			为了向您提供更完善、优质的产品和服务，某些功能可能由我们的技术服务合作方提供，我们可能会委托合作方处理您的某些个人信息，并征得您的同意。对我们委托处理您个人信息的公司、组织和个人，我们会与其签署严格的保密协定，明确双方责任、处理事项、处理期限、处理性质和处理目的等，要求他们仅按照我们的要求、本协议以及其他任何相关的保密和安全措施来处理个人信息。如果您拒绝我们的合作方在提供服务时收集为提供服务所必需的个人信息，将可能导致您无法使用浙江新闪新能源科技有限公司的部分或全部服务或该合作方提供的服务。
		</p>

		<p>5.2 共享</p>

		<p>对于您的个人信息，我们仅在本协议所述的目的和范围内或根据法律法规的要求收集和使用，并严格保密。除非存在以下一种或多种情形（相关法域另有规定的除外），我们不会与第三方公司、组织或个人共享您的个人信息：</p>

		<p>5.2.1 基于您自行提出的要求、或事先获得您的明示授权或同意；</p>
		<p>5.2.2 与我们履行法律法规规定的义务相关的；</p>
		<p>5.2.3 与国家安全、国防安全直接相关的；</p>
		<p>5.2.4 与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p>5.2.5 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		<p>5.2.6 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		<p>5.2.7 您自行向社会公众公开的您个人信息；</p>
		<p>5.2.8 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道；</p>
		<p>5.2.9 与我们的关联公司进行必要的共享；</p>
		<p>5.2.9.1
			保障我们能通过平台向您提供产品和服务，推荐您可能感兴趣的信息或保护关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本协议中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
		</p>
		<p>5.2.10 与我们的业务合作伙伴进行必要的信息共享。</p>

		<p>
			为了向您提供更完善、优质的产品和服务，某些服务可能实质上将由合作方提供。因此，我们可能会与合作方共享您的某些个人信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享为您提供服务所必要的个人信息。我们不会共享可以识别您身份的个人信息，除非法律法规另有规定。该等共享的合作方为数据控制者，以其自己的名义获得您的同意以处理您的个人信息。合作方可能有其独立的隐私政策和用户协议，我们建议您认真阅读并遵守第三方的用户协议及隐私政策。如果您拒绝我们的合作方在提供服务时收集为提供服务所必需的个人信息，将可能导致您无法使用我们的产品与服务来享用该合作方提供的服务。在您使用我们的产品与服务时，我们可能会与我们的合作伙伴（含渠道合作方）共享您的信息。在这种情况下，共享信息将被视为即时并广泛的传播。一旦您进行了此类信息共享，很难确保当您需要删除信息时，您所共享的信息在所有接受转发的互联网平台中被全部删除。在一些情况下，即使您从我们的服务中删除了您共享的信息，该类信息仍然可能会留存在公众可获知的领域，仍可由其他用户或与我们没有关联且不受我们控制的第三方独立地缓存、复制或存储，以及通过其他用户或该等第三方在公众可获知的领域保存。
		</p>

		<p>5.2.11 其他根据法律法规的规定、有权机关的要求，或是为了依法维护我们与我们客户的合法权益，或是经您明示同意的。</p>

		<p>请您知悉：</p>

		<p>（1）我们共享您的个人信息仅为了更精准地向您提供服务。除此以外，我们不会共享可以识别您身份的个人信息，除非法律法规另有规定。</p>

		<p>
			（2）通过充电产品与服务或第三方提供的功能，您可以主动公开、共享您的信息。在这种情况下，共享信息将被视为即实并广泛的传播。一旦您进行了此等共享，很难确保当您需要删除信息时，您所共享的信息在所有接受转发的互联网平台中被全部删除。在一些情况下，即使您从充电产品与服务中删除了被共享的信息，该等信息仍然可能会留存在公众可获知的领域，仍可由其他用户或与我们没有关联及不受我们控制的第三方独立地缓存、复制或存储，或通过其他用户或该等第三方在公众可获知的领域保存。
		</p>

		<p>5.3 转让</p>

		<p>原则上我们不会将您的个人信息控制权向其它公司、组织或个人进行转让，但在以下情况除外：</p>

		<p>5.3.1 基于您自行提出的要求、或事先获得您的明示授权或同意；</p>
		<p>5.3.2 与我们履行法律法规规定的义务相关的；</p>
		<p>5.3.3 与国家安全、国防安全直接相关的；</p>
		<p>5.3.4 与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p>5.3.5 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		<p>5.3.6 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		<p>5.3.7 您自行向社会公众公开的您个人信息；</p>
		<p>5.3.8 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
		<p>5.3.9 发生公司合并、收购或破产清算，运营主体的变更时的转让。</p>

		<p>请您知悉：如具备上述事由确需转让，我们将在转让前向您告知转让信息的目的、类型、信息受让方（如涉及敏感信息，我们还将告知涉及的敏感信息的内容），并在征得您同意后再转让，但法律法规另有规定的除外。</p>

		<p>5.4 公开披露</p>

		<p>原则上我们不会向社会或不特定人群发布您的个人信息，但以下情况除外：</p>

		<p>5.4.1 基于您自行提出的要求、或事先获得您的明示授权或同意；</p>
		<p>5.4.2 与我们履行法律法规规定的义务相关的；</p>
		<p>5.4.3 与国家安全、国防安全直接相关的；</p>
		<p>5.4.4 与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p>5.4.5 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		<p>5.4.6 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		<p>5.4.7 您自行向社会公众公开的您个人信息；</p>
		<p>5.4.8 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

		<p>5.4.9
			请您知悉，如具备上述事由确需公开披露，我们会在披露前向您告知公开披露的目的、信息的类型（如涉及敏感信息，我们还将告知涉及的敏感信息的内容）并在征得您同意后再公开披露，但法律法规另有规定的除外。即使已经取得您的同意，我们也仅会处于合法、正当、必要、特定、明确的目的公开披露您的个人信息，并尽量对公开披露内容中的个人信息进行去标识化处理。
		</p>

		<p>5.5收集、使用与对外提供的特殊情形</p>

		<p>根据法律法规，以下情形中收集和使用您的个人信息无需征得您的同意：</p>

		<p>5.5.1与履行法律法规规定的义务相关的；</p>
		<p>5.5.2与国家安全、国防安全直接相关的；</p>
		<p>5.5.3与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p>5.5.4 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		<p>5.5.5 出于维护您或其他用户的生命、财产等重大合法权益相关但又很难得到本人同意的；</p>
		<p>5.5.6所涉及的个人信息是您自行向社会公众公开的；</p>
		<p>5.5.7 根据您要求签订和履行合同所必需的；</p>
		<p>5.5.8 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
		<p>5.5.9维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置我们的产品与/或服务的故障；</p>
		<p>5.5.10法律法规规定的其他情形。</p>

		<p><strong>六、未成年人的个人信息保护</strong></p>

		<p>
			1、浙江新闪新能源科技有限公司非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。浙江新闪新能源科技有限公司根据国家相关法律法规的规定保护未成年人的个人信息。
		</p>

		<p>2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>

		<p>3、如果有事实证明未成年人并未取得父母或法定监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。</p>

		<p><strong>七、通知和修订</strong></p>

		<p>
			1、为给您提供更好的服务以及随着浙江新闪新能源科技有限公司充电业务的发展，本隐私协议也会随之更新。但未经您明确同意，我们不会削减您依据本隐私协议所应享有的权利。我们会通过在浙江新闪新能源科技有限公司充电上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问微信“浙江新闪新能源科技有限公司”小程序以便及时了解最新的隐私政策。
		</p>

		<p>2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于电子邮件、短信发送通知或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</p>

		<p>3、本协议所指的重大变更包括但不限于：</p>

		<p>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
		<p>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
		<p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
		<p>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
		<p>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
		<p>（6）个人信息安全影响评估报告表明存在高风险时。</p>

		<p>4、我们还会将本协议的旧版本存档，供您查阅。</p>

		<p><strong>八、如何联系我们</strong></p>

		<p>您可以随时拨打客服电话【400-806-0808】(法定假日除外)的方式与我们取得联系。</p>

		<p>注：本《隐私协议》于2024年1月1日正式生效。</p>
	</div>
</template>

<script>
</script>

<style>
	.word-wrap {
		max-height: 80vh;
		width: 100%;
	}
</style>